import { QueryClient } from '@tanstack/react-query';

/**
 * The app's one react-query cache.
 *
 * A module of its own so the logout can empty it (F29): every way out of a
 * session goes through `logoutToken`, and none of them reloads the page — the
 * next person to sign in on this browser would otherwise be served the
 * previous one's dashboards, tables and agents from memory until each query
 * happened to refetch.
 */
export const queryClient = new QueryClient();
